import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import LabelSection from 'components/sections/LabelSection';
import ActionBarDetailWrapper from 'components/wrappers/pages/ActionBarDetailWrapper';
import {
  setDeletedModifier,
  showDeleteModifierModal,
  onClickCancel,
} from 'actions/businessLibrary/modifier';
import settingField from 'components/Fields/ReduxForm/SettingField/SettingField';

import styles from './ModifierForm.css';
import ModifierOptions from './ModifierOptions';
import ModifierOptionsModal from './ModifierOptionsModal';

const validate = values => {
  const errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'This field is required';
  } else if (values.name.length > 100) {
    errors.name = 'Name max 100 char';
  }
  return errors;
};

class ModifierForm extends React.Component {
  render() {
    const {
      handleSubmit,
      modifier,
      isSubmittingForm,
      onClickCancel,
      onSubmit,
    } = this.props;

    return (
      <form className={styles.wrapper}>
        <div
          className={`${styles['content-wrapper']} modifier-content-wrapper`}
        >
          <div className="row mb-20px">
            <div className="col-sm-12">
              <Field component="input" type="hidden" name="id" />
              <LabelSection title="modifier set" />
              <div className="form-group">
                <Field
                  component={settingField}
                  name="name"
                  type="text"
                  placeholder="Name"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <LabelSection title="modifier options" />
          <ModifierOptions />
        </div>
        <ActionBarDetailWrapper>
          <span className="pull-left">
            {modifier.id && (
              <button
                className="btn btn-danger"
                type="button"
                onClick={this.onClickDelete}
                disabled={isSubmittingForm}
              >
                <i className="fa fa-trash" />{' '}
              </button>
            )}
          </span>
          <span className="pull-right">
            <button
              className="btn btn-default mr-10px"
              type="button"
              onClick={onClickCancel}
              disabled={isSubmittingForm}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmit(onSubmit)}
              disabled={isSubmittingForm}
            >
              Save
            </button>
          </span>
        </ActionBarDetailWrapper>
        <ModifierOptionsModal />
      </form>
    );
  }

  onClickDelete = () => {
    const {
      modifierDetail,
      setDeletedModifier,
      showDeleteModifierModal,
    } = this.props;
    setDeletedModifier(modifierDetail);
    showDeleteModifierModal();
  };
}
const mapForm = {
  form: 'modifierHub',
  touchOnBlur: false,
  touchOnChange: false,
  validate,
  destroyOnUnmount: false,
};

const selector = formValueSelector('modifierHub');

function mapStateToProps(state) {
  const {
    modifierDetail,
    isSubmittingForm,
  } = state.businessLibrary.modifierHub;
  return {
    modifier: {
      id: selector(state, 'id'),
    },
    modifierDetail,
    isSubmittingForm,
  };
}

const mapDispatchToProps = {
  setDeletedModifier,
  showDeleteModifierModal,
  onClickCancel,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ModifierForm));
